import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChevronDown = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 12 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="m2.64645 4.64645c.19526-.19527.51184-.19527.7071 0l2.64645 2.64644 2.64645-2.64644c.19526-.19527.51184-.19527.7071 0 .19527.19526.19527.51184 0 .7071l-3 3c-.19526.19527-.51184.19527-.7071 0l-3-3c-.19527-.19526-.19527-.51184 0-.7071z"
        />
      </svg>
    )
  },
)

export default ChevronDown
